export const LOADING_LABELS = {
  page: 'Loading…',
  session: 'Checking your session…',
  saving: 'Saving…',
  opening: 'Opening…',
  deleting: 'Deleting…',
  updating: 'Updating…',
  signingIn: 'Signing in…',
} as const
